import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { ConfigurationModel, ConfigurationDefaultModel, MinMaxModel, WashBasinModel, WashBasinDefaultModel } from 'franke-trough-dependencies';
import { GlobalPrivateState, } from 'src/api';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { difference as _diff } from 'lodash';
import { DebounceInput } from 'react-debounce-input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './BasinDimensions.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface AngleOfNicheProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: any;
}

export interface AngleOfNicheState {
  angleOfNiche: null | number[];
  angleError: boolean;
}

export class AngleOfNichePartial extends React.Component<AngleOfNicheProps, AngleOfNicheState> {

  constructor(props: AngleOfNicheProps) {
    super(props);
    this.state = {
      angleOfNiche: this.angleOfNiche || (this.angleOfNicheDefaults && this.angleOfNicheDefaults.default) || null,
      angleError: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  
  public render() {
    if (this.configuration && this.angleOfNicheDefaults) {
      const { angleOfNiche, angleError } = this.state;
      
      return (
        <div className="partial-angle-of-nice pb-4">
          <div className="form-group">
            <div className="row">
              {angleOfNiche === null && (
                <div className="col-12">
                  <p>
                    <small>
                      <FormattedMessage {...MESSAGES.angleOfNicheNotSelectAble} />
                    </small>
                  </p>
                </div>
              )}
              {angleOfNiche && angleOfNiche.map((value, index) => {
                const key = `angle_of_niche_input_${index}`;
                const name = `angleOfNiche${index}`;
                const defaults = this.angleOfNicheDefaults && this.angleOfNicheDefaults.values;
                return (
                  <div key={key} className={classNames('col-6', {'mb-3': (angleOfNiche.length + 1) !== index})}>
                    {index === 0 && (
                      <label className="small mb-2">
                        {this.typeOfInstallation === 'right' && (
                          <FormattedMessage {...MESSAGES.angleOfNicheLabelRight} />
                        )}
                        {this.typeOfInstallation === 'left' && (
                          <FormattedMessage {...MESSAGES.angleOfNicheLabelLeft} />
                        )}
                        {this.typeOfInstallation === 'with' && (
                          <FormattedMessage {...MESSAGES.angleOfNicheLabelLeft} />
                        )}
                      </label>
                    )} 
                    {index === 1 && (
                      <label className="small mb-2">
                        <FormattedMessage {...MESSAGES.angleOfNicheLabelRight} />
                      </label>
                    )} 
                    <DebounceInput
                      className="form-control"
                      disabled={this.disabled}
                      field={name}
                      name={name}
                      type="number"
                      min={defaults && defaults.min || 88}
                      max={defaults && defaults.max || 92}
                      onChange={(event: React.SyntheticEvent<HTMLInputElement>) => this.handleChange(event, index)}
                      value={value.toString()}
                      debounceTimeout={500}
                      step="0.1"
                    />
                  </div>
                );
              })}
              <div className="col-12 error-tooltip">
                {angleError && (
                  <label className="small mb-4">
                    <span className="info-icon" id="UncontrolledTooltipExample">
                      <FontAwesomeIcon icon={faInfo} />
                      <UncontrolledTooltip placement="right" target="UncontrolledTooltipExample">
                        <FormattedMessage {...MESSAGES.inputOutOfRangeError} />
                      </UncontrolledTooltip>
                    </span>
                  </label>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  private get angleOfNiche(): number[] | undefined {
    return this.getAngelOfNiche();
  }

  private get angleOfNicheDefaults(): WashBasinDefaultModel['angleOfNiche'] | undefined {
    const configurationDefaults = this.configuration && this.configuration.defaults;
    return configurationDefaults && 
      configurationDefaults &&
      configurationDefaults.washBasinDimension &&
      configurationDefaults.washBasinDimension.angleOfNiche;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration.result;
  }

  private get disabled() {
    return !isConfigurationEditable();
  }

  private dispatchConfiguration(angleOfNiche: number[]): void {
    if (!this.configuration || !this.configuration.washBasinDimension || this.disabled) { return; }

    const { washBasinDimension } = this.configuration;
    const data: WashBasinModel = washBasinDimension;
    data.angleOfNiche = angleOfNiche;
    
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {washBasinDimension: data}
        },
      },
      true,
    ));
  }

  private getAngelOfNiche(props?: AngleOfNicheProps): number[] | undefined {
    const { configuration } = props || this.props;
    return configuration && 
      configuration.result &&
      configuration.result.washBasinDimension &&
      configuration.result.washBasinDimension.angleOfNiche ? configuration.result.washBasinDimension.angleOfNiche : undefined;
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>, index: number) {
    const target = event.target as HTMLInputElement;
    const value = Number(target.value);
    const values = this.state.angleOfNiche;

    if (target.value !== '' && value > 0) {
      if (values && values[index]) {
        values[index] = value;
      }
      const isValid = this.angleOfNicheDefaults ? this.validateMinMax(value, this.angleOfNicheDefaults.values) : false;
      
      this.setState({
        angleOfNiche: values,
        angleError: !isValid,
      });
  
      if (isValid && values) {
        this.dispatchConfiguration(values);
      }
    }
  }

  private get typeOfInstallation(): WashBasinModel['typeOfInstallation'] | undefined | null {
    return this.configuration && 
      this.configuration.washBasinDimension && 
      this.configuration.washBasinDimension.typeOfInstallation;
  }

  private validateMinMax(value: number, values: MinMaxModel): boolean {
    if (value > values.max || value < values.min) {
      return false;
    }
    return true;
  }
}

export const AngleOfNiche = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration
}))(AngleOfNichePartial);

export default AngleOfNiche;